/**
 * LZ Collection Card — switcher millésime
 * Activé sur toutes les cartes .lz-collection__card de la page (collection + reco produit).
 */
(function() {
  function formatMoney(cents) {
    if (cents === null || cents === undefined) return '';
    var v = cents / 100;
    return v.toFixed(2).replace('.', ',') + ' €';
  }

  function getActiveMillesimeFromURL() {
    var params = new URLSearchParams(window.location.search);
    var found = null;
    params.forEach(function(value, key) {
      if (found) return;
      if (key.indexOf('filter.v.option') === 0) found = value;
    });
    return found;
  }

  function initCard(card) {
    if (card.dataset.lzCardInit === '1') return;
    card.dataset.lzCardInit = '1';

    // Mode "fixed" (split par millésime) : pas de switcher, le SSR fait foi → on ne touche à rien.
    if (!card.querySelector('[data-lz-vintage-switcher]')) return;

    var dataScript = card.querySelector('[data-lz-product-options]');
    if (!dataScript) return;
    var data;
    try { data = JSON.parse(dataScript.textContent); } catch(e) { return; }

    var showPromoDetails = data.show_promo_details === true;
    var millesimes = (data.millesimes_data || []).slice();
    millesimes.sort(function(a, b) {
      return String(b.m).localeCompare(String(a.m), undefined, { numeric: true });
    });

    if (millesimes.length < 2) {
      var switcher = card.querySelector('[data-lz-vintage-switcher]');
      if (switcher && millesimes.length <= 1) {
        var arrows = switcher.querySelectorAll('.lz-collection__card-vintage-arrow');
        arrows.forEach(function(a) { a.style.visibility = 'hidden'; });
      }
      return;
    }

    // Millésime affiché au chargement : celui du filtre d'URL, sinon le premier en stock
    var currentIdx = 0;
    for (var j = 0; j < millesimes.length; j++) {
      if (millesimes[j].available !== false) { currentIdx = j; break; }
    }
    var activeMillesime = getActiveMillesimeFromURL();
    if (activeMillesime) {
      for (var i = 0; i < millesimes.length; i++) {
        if (String(millesimes[i].m) === String(activeMillesime)) {
          currentIdx = i;
          break;
        }
      }
    }

    // Préchargement des images de tous les millésimes (cache navigateur)
    millesimes.forEach(function(m) {
      if (!m.img) return;
      var preload = new Image();
      if (m.img_srcset) preload.srcset = m.img_srcset;
      preload.src = m.img;
    });

    var labelEl = card.querySelector('[data-lz-vintage-value]');
    var priceEl = card.querySelector('[data-lz-price-current]');
    var compareEl = card.querySelector('[data-lz-price-compare]');
    var ctaEl = card.querySelector('[data-lz-card-cta]');
    var imageLinks = card.querySelectorAll('[data-lz-card-link]');
    var imageEl = card.querySelector('.lz-collection__card-image');
    var badgeEl = card.querySelector('[data-lz-card-badge]');
    var soldoutBadgeEl = card.querySelector('[data-lz-card-soldout]');
    var soldoutText = soldoutBadgeEl ? soldoutBadgeEl.textContent.trim() : 'Épuisé';
    var ctaLabel = ctaEl ? (ctaEl.getAttribute('data-lz-cta-label') || 'Acheter') : 'Acheter';
    var prevBtn = card.querySelector('[data-lz-vintage-prev]');
    var nextBtn = card.querySelector('[data-lz-vintage-next]');

    function render() {
      var m = millesimes[currentIdx];
      if (!m) return;
      if (labelEl) labelEl.textContent = m.m;
      var displayPrice = m.unit_price || m.price;
      if (priceEl) priceEl.textContent = formatMoney(displayPrice);
      if (compareEl) {
        // Le prix barré n'est affiché que sur la collection "Promotions"
        // (métafield collection.custom.affichage_promotion = true).
        if (!showPromoDetails) {
          compareEl.setAttribute('hidden', '');
        } else {
          var displayCompare = m.compare_at;
          if (m.compare_at && m.unit_price && m.price) {
            displayCompare = Math.round(m.compare_at * (m.unit_price / m.price));
          }
          if (displayCompare && displayCompare > displayPrice) {
            compareEl.textContent = formatMoney(displayCompare);
            compareEl.removeAttribute('hidden');
          } else {
            compareEl.setAttribute('hidden', '');
          }
        }
      }
      if (ctaEl) ctaEl.setAttribute('href', m.url);
      imageLinks.forEach(function(a) { a.setAttribute('href', m.url); });
      if (imageEl && m.img) {
        imageEl.setAttribute('src', m.img);
        if (m.img_srcset) imageEl.setAttribute('srcset', m.img_srcset);
      }
      // Rupture de stock : badge "Épuisé", bouton désactivé, image atténuée
      var soldout = (m.available === false);
      card.classList.toggle('lz-collection__card--soldout', soldout);
      if (soldoutBadgeEl) {
        if (soldout) soldoutBadgeEl.removeAttribute('hidden'); else soldoutBadgeEl.setAttribute('hidden', '');
      }
      if (ctaEl) {
        ctaEl.classList.toggle('is-soldout', soldout);
        ctaEl.textContent = soldout ? soldoutText : ctaLabel;
        if (soldout) ctaEl.setAttribute('aria-disabled', 'true'); else ctaEl.removeAttribute('aria-disabled');
      }
      if (badgeEl) {
        // Badge "Promotion" : true dès qu'AU MOINS UN variant de ce millésime
        // est soldé (tous formats : Magnum, Jéroboam, etc.), pas seulement le 0.75L.
        // Masqué quand le millésime est épuisé (le badge "Épuisé" prend sa place).
        if (m.any_sale && !soldout) {
          badgeEl.removeAttribute('hidden');
        } else {
          badgeEl.setAttribute('hidden', '');
        }
      }
      if (prevBtn) prevBtn.disabled = (currentIdx === 0);
      if (nextBtn) nextBtn.disabled = (currentIdx === millesimes.length - 1);
    }

    render();

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (currentIdx > 0) { currentIdx--; render(); }
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (currentIdx < millesimes.length - 1) { currentIdx++; render(); }
      });
    }
  }

  // Switcher de photos des cartes accessoires (même mécanique que le switcher de millésime)
  function initPhotoCard(card) {
    if (card.dataset.lzPhotoInit === '1') return;
    card.dataset.lzPhotoInit = '1';
    var switcher = card.querySelector('[data-lz-photo-switcher]');
    var dataScript = card.querySelector('[data-lz-photos]');
    var imgEl = card.querySelector('[data-lz-photo-img]');
    if (!switcher || !dataScript || !imgEl) return;
    var photos;
    try { photos = JSON.parse(dataScript.textContent); } catch(e) { return; }
    if (photos.length < 2) return;
    photos.forEach(function(p) { var pre = new Image(); if (p.srcset) pre.srcset = p.srcset; pre.src = p.src; });
    var idx = 0;
    var dots = switcher.querySelectorAll('[data-lz-photo-dots] i');
    function render() {
      var p = photos[idx];
      imgEl.setAttribute('src', p.src);
      if (p.srcset) imgEl.setAttribute('srcset', p.srcset);
      dots.forEach(function(d, i) { d.classList.toggle('is-active', i === idx); });
    }
    var prev = switcher.querySelector('[data-lz-photo-prev]');
    var next = switcher.querySelector('[data-lz-photo-next]');
    if (prev) prev.addEventListener('click', function(e) { e.preventDefault(); idx = (idx - 1 + photos.length) % photos.length; render(); });
    if (next) next.addEventListener('click', function(e) { e.preventDefault(); idx = (idx + 1) % photos.length; render(); });
  }

  function initAll() {
    document.querySelectorAll('.lz-collection__card').forEach(initCard);
    document.querySelectorAll('.lz-collection__card--accessoire').forEach(initPhotoCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
